import React, { useState } from 'react';
import { Typography, Box } from '@mui/material';
import { toast } from 'react-toastify';
import _ from 'lodash';

import {
  TreeList,
  Column,
  Paging,
  Pager,
  Lookup,
  Scrolling,
  Editing
} from 'devextreme-react/tree-list';
import CustomStore from 'devextreme/data/custom_store';
import { SearchPanel } from 'devextreme-react/data-grid';

import { useApi } from '../../../../context/api';

import { AccountInfo, ShortAccountInfo } from './types';

const expandedRowKeys = [1];
const defaultPageSize = 10;
const allowedPageSizes = [5, 10, 20];

export default function AccountsTreeList() {
  const { apiInstance } = useApi();

  const [accountsData, setAccountsData] = useState(new CustomStore({
      key: 'id',
      load: () => getData('/companies/tree-list'),
      update: (key, values) => updateData(`/companies/tree-list/${key}`, key, values),
    })
  );

  const [shortAccountsList, setShortAccountsList] = useState([]);

  const getData = async (url: string) => {
    const response: any = await apiInstance.get(url);
    const shortList = response?.accountList?.map((item: AccountInfo) => {
      return {
        id: item.id,
        name: item.name
      }
    })

      shortList?.unshift({
        id: null,
        name: 'Not selected'
      });

    setShortAccountsList(shortList);
    return {
      // eslint-disable-next-line
      // @ts-ignore
      data: response?.accountList,
    };

  };

  const updateData = async (url: string, key: any, values: any) => {
    try {
      const res = await apiInstance.post(url, values);
      toast.success(_.get(res, 'msg', 'Saved successfully'));
      return res;
    } catch (error) {
      const msg = _.get(
        error, 'error.message', 'Error while saving. Please check the parameters'
      );
      toast.error(msg);
      throw new Error(msg || 'Unknown network error');
    }
    return {};
  }


  return (
    <>
      <Box
        sx={{
          position: 'relative',
          justifyContent: 'space-between',
          paddingLeft: '0px',
          paddingBottom: '0px',
          top:'30px',
          paddingTop: '10px',
        }}>
        <Typography
          data-test={'titleTreeList'}
          variant="h5"
        >
          {'Accounts Tree List'}
        </Typography>
      </Box>
      <TreeList
        id="accounts-list"
        dataSource={accountsData}
        wordWrapEnabled={true}
        rootValue={null}
        defaultExpandedRowKeys={expandedRowKeys}
        showRowLines={true}
        showBorders={true}
        columnAutoWidth={true}
        keyExpr="id"
        parentIdExpr="mainAccountId"
      >
        <Scrolling
          mode="standard" />
        <SearchPanel visible={true} highlightCaseSensitive={true} />
        <Editing
          allowUpdating={true}
          mode="row"
          useIcons={true}
        />
        <Paging
          defaultPageSize={defaultPageSize}
          enabled={true}
        />
        <Pager
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
        />
        <Column
          dataField="name"
          caption="Name"
          allowEditing={false}
        />
        <Column
          dataField="address"
          caption="Address"
          allowEditing={false}
        />
        <Column
          dataField="city"
          caption="City"
          allowEditing={false}
        />
        <Column
          dataField="state"
          caption="State"
          allowEditing={false}
        />
        <Column
          dataField="country"
          caption="Country"
          allowEditing={false}
        />
        <Column
          dataField="zip"
          caption="Zip"
          allowEditing={false}
        />
        <Column
          dataField="tz"
          caption="Time zone"
          allowEditing={false}
        />
        <Column
          dataField="mainAccountId"
          allowSorting={false}
          caption="Main account"
          width={200}
          cellRender={(cell) => {
            if (cell.data.mainAccountId == null) {
              return null;
            }
            return <span>{cell.data.mainAccountName}</span>;
          }}
        >
          <Lookup
            dataSource={
              {
                store: shortAccountsList,
                paginate: true,
                pageSize: 10
              }
            }
            displayExpr="name"
            valueExpr="id"
          />
        </Column>
      </TreeList>
    </>
  );
}
